import client from "./client";

const getRoles = () => client.get("/subsidiary/dashboard/role/users");

export default { getRoles };
